// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2Mbpw","title":"FrontImage_title__10KRJ"};